import { RootState } from "../../app/store";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE, IS_LITE, LITE_TOKEN } from "../../app/const";
import { fireauth } from "../auth/AuthSlice";

export interface ChatConvState {
  status: 'idle' | 'loading' | 'failed'
  data: any[]
  fault: any
  currentQ: string
  chatGenesis: any
}
const initialState: ChatConvState = {
  status: 'idle',
  data: [],
  fault: '',
  currentQ: '',
  chatGenesis: ''
}

export const askAiAsync = createAsyncThunk('chatConv/askAi', async ({ content, slug, callback }: { content: string, slug: string, callback?: (slug: string) => void }, { getState }) => {
  const state = getState() as RootState
  const messages = []
  if (messages.length == 0) {
    state.chatConv.chatGenesis.forEach((e: any) => messages.push(e))
  }
  state.chatConv.data.forEach((e: any) => messages.push(e))
  messages.push({ role: 'user', content })
  return axios.post(`${API_BASE}apps/${slug}/chat`, { messages }, {
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "Authorization": `Bearer ${IS_LITE ? LITE_TOKEN : await fireauth.currentUser?.getIdToken()}`
    }
  }).then((response) => {
    if (callback) callback(slug)
    return response
  })
})

export const chatConvSlice = createSlice({
  name: 'chatConv',
  initialState,
  reducers: {
    setChatGenesis: (state, action: PayloadAction<any>) => {
      state.chatGenesis = action.payload
    },
    addNewChatConv: (state, action: PayloadAction<any>) => {
      state.data.push(action.payload)
    }
  }, extraReducers: (builder) => {
    builder.addCase(askAiAsync.pending, (state) => {
      state.status = 'loading'
    }).addCase(askAiAsync.fulfilled, (state, action) => {
      state.status = 'idle'
      state.data.push(action.payload?.data?.choices[0]?.message)
      state.fault = ''
    }).addCase(askAiAsync.rejected, (state, action) => {
      state.status = 'idle'
      state.fault = action.error.message
    })
  }
})

export const { setChatGenesis, addNewChatConv } = chatConvSlice.actions
export const selectStatus = (state: RootState) => state.chatConv.status
export const selectChatConv = (state: RootState) => state.chatConv.data as any
export default chatConvSlice.reducer